import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DetailViewFeatureParams } from '../../component/detail-view/detail-view.model';

@Injectable({
  providedIn: 'root',
})
export class SelectionNotifyService {
  private selection: number[] = [];
  private selectionFeature: DetailViewFeatureParams;

  public readonly onClearSubject: Subject<void> = new Subject();
  public readonly onSelectionChangeSubject: Subject<any[]> = new Subject();
  public readonly onRemoveSelectionSubject: Subject<any[]> = new Subject();

  constructor() {}

  public selectionFeatures(selectedIds: number[], selectedFeatures: DetailViewFeatureParams) {
    this.selection = selectedIds;
    this.selectionFeature = selectedFeatures;
    this.onSelectionChangeSubject.next(selectedIds);
  }

  public getSelection(): number[] {
    return this.selection;
  }

  public getSelectionFeature(): any {
    return this.selectionFeature;
  }

  public removeFromSelection(objectIds: number[]) {
    this.onRemoveSelectionSubject.next(objectIds);
  }

  public clearSelection() {
    this.selectionFeatures([], new DetailViewFeatureParams());
    this.onClearSubject.next();
  }
}
